import type { UserInvestmentProfile } from '@fruitful/investment-management';

import { requestBuilder } from '../../http/RequestBuilder';

interface UseGetUserInvestmentProfileParams {
    userId: string;
}

const useGetUserInvestmentProfileQuery = requestBuilder.query<
    UserInvestmentProfile,
    UseGetUserInvestmentProfileParams
>({
    endpoint: ({ userId }) => `/api/user/${userId}/investment-profile`,
    queryKey: ({ userId }) => `/user/${userId}/investment-profile`,
});

export const useGetUserInvestmentProfile = (
    params: UseGetUserInvestmentProfileParams,
) => {
    return useGetUserInvestmentProfileQuery(params);
};
